import { cn } from 'components/lib/utils';

export const TAB_TRIGGER_STYLES = cn(
  'rounded-none border-b-2 border-transparent px-0 pb-2 pt-0 text-p-s font-medium',
  'data-[state=active]:border-indigo-500 data-[state=active]:text-indigo-600',
  'data-[state=active]:bg-transparent data-[state=active]:shadow-none',
  'text-base-mutedForeground hover:text-base-foreground'
);

export const EMPTY_RESPONSE_MESSAGE = { message: 'No response yet. Click "Test" to send a request.' };

export const INTEGRATION_TEST_MODAL_CONSTANTS = {
  FORM_ID: 'integration-test-form',
  DEFAULT_TITLE: 'Request Configuration',
  DEFAULT_DESCRIPTION: 'Set the parameters for testing the callback.',
  TESTING_BUTTON_TEXT: 'Testing...',
  TEST_BUTTON_TEXT: 'Test',
  RESPONSE_TITLE: 'Response',
  BODY_TAB: 'Body',
  HEADERS_TAB: 'Headers',
};export const JSON_FIELD_CONSTANTS = {
  ARRAY_PLACEHOLDER: '[{}]',
  OBJECT_PLACEHOLDER: '{}',
  ARRAY_HELPER_TEXT: 'Enter array as JSON (e.g., [{ "key": "value" }] or ["value1", "value2"])',
  OBJECT_HELPER_TEXT: 'Enter object as JSON (e.g., { "key": "value" })',
};
